import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const NotificationManagementService = {};

// List Notification
NotificationManagementService.listNotification = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/notifications`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "caseDocsign",
    },
  });
};

// List Notification Header
NotificationManagementService.listNotificationHeader = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/my/latest-notifications`,
    method: "get",
    params: {
      limit: params.limit || 10,
      expand: params.expand || "caseDocsign",
    },
  });
};

// Detail Notification
NotificationManagementService.detailNotification = function ({
  notificationId,
  params,
}) {
  return fetch({
    url: `${env.API_MSP}/notifications/${notificationId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "userNotifications,userNotifications.user",
    },
  });
};

export default NotificationManagementService;
